// extracted by mini-css-extract-plugin
export default {"readMore":"TPq4Ivv3","mobile":"mobile","title":"ciyKsDCj"};